const faquestion = [
  {
    index: 0,
    name: "question01-content",
    nameId: "question01-header",
    title: "HOW DO I RETURN MY ORDER?",
    desc: "You can return your online order within 30 days of receiving your order. Before returning an item, please check out our Returns/ Refunds policy and Condition & requirement for returning item to make sure your item is eligible for return",
  },
  {
    index: 1,
    name: "question02-content",
    nameId: "question02-header",
    title: "WHY WAS MY ONLINE ORDER CANCELLED?",
    desc: "Sometimes we have to cancel orders. This can be due to a number of reasons, including: Stock availability. It is most likely that your size ran out of stock before we could process your order. Payment issues. Your payment did not go through or we were not able to verify your payment details. Delivery address issues. You may have accidentally entered an incorrect or incomplete delivery address which we couldn’t process.",
  },
  {
    index: 2,
    name: "question03-content",
    nameId: "question03-header",
    title: "CAN I CHANGE MY DELIVERY ADDRESS?",
    desc: "Once your order has been placed, it immediately starts going through our ordering process. Therefore, we unfortunately cannot cancel or change your order or order details even if it has not been shipped yet. Once you receive your order, you may return any products you don't want by following our Return Policy.",
  },
  {
    index: 3,
    name: "question04-content",
    nameId: "question04-header",
    title: "HOW DO I USE MY VOUCHER CODE?",
    desc: "Click the Checkout button at the top of the page to go to your shopping bag. Under the order summary click 'Enter promo code' then type your voucher code into the box and click 'Apply'",
  },
  {
    index: 4,
    name: "question05-content",
    nameId: "question05-header",
    title: "HOW DO I TRACK MY ORDER OR DELIVERY STATUS?",
    desc: "Once your order has been dispatched from our warehouse you will receive a shipping confirmation email with your tracking number and link to track your order online. You will then be able to to track your order via the online tracker.",
  },
];

export default faquestion;
